import NewsList from './NewsList';
import NoticeIcon from '@material-ui/icons/Public';

const NoticeModule = {
    list: NewsList,
    icon: NoticeIcon
}

export default NoticeModule;